/*
 * @Author: cn1994
 * @Date: 2022-10-19 16:22:49
 * @LastEditors: cn1994
 * @LastEditTime: 2024-03-03 15:07:59
 * @Description: 课堂评价
 */
const routes = [
  {
    path: "/remark/detail",
    name: 'remark/detail',
    meta: {
      title:'评价详情',
      hasBack: true,
    },
    component: () =>
      import("../pages/courseRemark/remarkDetail/remarkDetail.vue"),
  },
  {
    path: "/remark/edit",
    name: "remark/edit",
    meta: {
      title:'评价',
      hasBack: true,
    },
    component: () =>
      import("../pages/courseRemark/remarkDetail/editRemark.vue"),
  },
  // 课堂评价首页
  {
    path: "/remark",
    name: 'remark',
    meta: {
      title:'课堂评价',
      hasBack: false,
      volcengine: true,
    },
    component: () => import("../pages/courseRemark/remarkHome.vue")
  },
  // 评语管理首页
  {
    path: "/remark/comment",
    name: 'remark/comment',
    meta: {
      title: '评语管理',
      hasBack: true,
    },
    component: () => import("../pages/courseRemark/remarkHouse.vue")
  },
  // 评语模版管理首页
  {
    path: "/remark/template",
    name: 'remark/template',
    meta: {
      title: '评语模版管理',
      hasBack: true,
    },
    component: () => import("../pages/courseRemark/scoringTemplate.vue")
  }
];
export default routes;
